var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.validationClasses },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.validationShow
        ? _c("p", { staticClass: "c-validation-message__message" }, [
            _c(
              "svg",
              {
                staticClass: "c-validation-message__icon",
                class: _vm.validationSVGClasses,
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [
                _vm.valid
                  ? _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#tick-1"
                      }
                    })
                  : _vm.invalid
                    ? _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#cross"
                        }
                      })
                    : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.validationMessage) }
            })
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4449d20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4449d20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/validation-message/ValidationMessage.vue
// module id = 667
// module chunks = 0